import { render, staticRenderFns } from "./GroupBannerDetail.vue?vue&type=template&id=57f6b8de&"
import script from "./GroupBannerDetail.vue?vue&type=script&lang=js&"
export * from "./GroupBannerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports